"use client";

import styled from "styled-components";

export const AudioUploadContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const UploadBox = styled.div`
  width: 100%;
  height: 60px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: transparent;

  span {
    font-size: 14px;
    color: var(--textLight);
  }
`;

export const AudioBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 0;
  border-radius: 50%;
  width: 100%;
  background: transparent;

  audio {
    outline: none;
    width: 100%;
    background: transparent;
  }
`;

export const Close = styled.button`
  position: absolute;
  top: -9px;
  right: 9px;
  background: var(--red);
  border: none;
  color: white;
  border-radius: 50%;
  padding: 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;
